// @ts-nocheck
import { FlowContextWithThemeProvider } from '@airwallex-dev-scale/core/dist/hosted-flow-utils';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { setLocale } from 'yup';

import { ContainerHistory } from '@/contexts/containerHistory';
import { ContainerContext } from '@/contexts/containerProps';
import type { RootProps } from '@/contexts/containerProps/rootProp';
import { LdFlags } from '@/contexts/ldFlags';
import { Pages } from '@/pages';

import { AppFlowProvider } from './contexts/appFlow';
// import { airTracker } from './utils/airTracker';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

export const App = (props: RootProps) => {
  const { themeProviderProps, featureFlags, containerHistory, account, user } =
    props;

  /**
   * globally set default error message
   * see client/src/utils/yupResolver.ts for replacement and i18n logic
   * default base config can be found in https://github.com/jquense/yup/blob/master/src/locale.ts
   */
  useEffect(() => {
    setLocale({
      mixed: {
        required: 'KYB_ERR_REQUIRED',
        notType: 'KYB_ERR_INVALID_TYPE',
      },
      number: {
        min: 'KYB_ERR_EXCEED_MIN',
        max: 'KYB_ERR_EXCEED_MAX',
        integer: 'KYB_ERR_SHOULD_BE_INTEGER',
        positive: 'KYB_ERR_SHOULD_BE_POSITIVE',
      },
    });
  }, []);

  useEffect(() => {
    if (account?.id) {
  /*     airTracker.setConfig({ accountId: account.id });
      airTracker.info('INIT', {
        accountId: account.id,
        userCountry: user.data?.country,
        userId: user.data?.user?.id,
        kycStatus: account.kycRecord?.status,
      }); */
    }
  }, [account?.id]);

  return (
    <ContainerContext.Provider value={props}>
      <ContainerHistory.Provider value={containerHistory ?? undefined}>
        <QueryClientProvider client={queryClient}>
          <LdFlags.Provider
            value={(featureFlags as unknown as Record<string, boolean>) ?? {}}
          >
            <FlowContextWithThemeProvider
              themeProviderProps={themeProviderProps}
            >
              <AppFlowProvider>
                <Pages />
              </AppFlowProvider>
            </FlowContextWithThemeProvider>
          </LdFlags.Provider>
        </QueryClientProvider>
      </ContainerHistory.Provider>
    </ContainerContext.Provider>
  );
};
